import React, { useContext } from 'react'
import { RenderOption } from 'app/React/Components/Main/RenderOption'
import { getOrderedOptionsCheckout } from 'utils/getOrderedOptionsCheckout'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

function CheckoutOverview() {
  const {
    cartItems,
    currentVariant,
    isAccessoryShop,
    order,
  } = useContext(ConfiguratorContext)

  const options = getOrderedOptionsCheckout(currentVariant, order.configuration, cartItems)

  return (
    <>
      {isAccessoryShop ? null : <RenderOption option={{
        title: order.configuration?.variants?.name ?? '',
        use_leasing_price: order.paymentType === 'cash' ? '0' : '1',
        price: order.paymentType === 'cash' ? parseInt(order.configuration?.engine_transmission?.price ?? 0) : undefined,
        price_leasing: order.paymentType === 'leasing' ? parseInt(order.leasing_price_range?.monthly_payment ?? 0) : undefined,
      }}/>}
      {options.map((option) => (
        <RenderOption key={option.id} option={option}/>
      ))}
    </>
  )
}

export default CheckoutOverview
